import type { gsap } from 'gsap';

export const ROUTES = ['/', '/rift', '/chaos'] as const;
/** Page 3 sets this session flag to '1' before navigating home after RESTORE REALITY. */
export const RESTORED_TIMELINE_KEY = 'chaosverse.timeline-restored.v1';
export type Route = (typeof ROUTES)[number];
export type Quality = 'auto' | 'cinematic' | 'lightweight';
export type Cue = 'initialize' | 'snap' | 'web' | 'portal' | 'restore';
export type Cleanup = () => void;

export interface Preferences {
  sound: boolean;
  volume: number;
  quality: Quality;
  cinematic: boolean;
  directorsCut: boolean;
}

export interface AudioService {
  unlock(): Promise<void>;
  cue(name: Cue): void;
  setMuted(muted: boolean): void;
  setVolume(volume: number): void;
  dispose(): void;
}

export interface MotionScope {
  reduced: boolean;
  context: ReturnType<typeof gsap.context>;
  dispose(): void;
}

export interface PageContext {
  host: HTMLElement;
  signal: AbortSignal;
  audio: AudioService;
  motion: MotionScope;
  preferences: Readonly<Preferences>;
  navigate(route: Route): Promise<void>;
  announce(message: string): void;
  registerSceneControls(controls: SceneControls): Cleanup;
}

export interface SceneControls {
  replay(): void;
  skip(): void;
  setDirectorsCut(enabled: boolean): void;
}

export interface PageModule {
  mount(context: PageContext): Cleanup | Promise<Cleanup>;
}

export interface AssetRecord {
  id: string;
  owner: 'lead' | 'page2' | 'page3';
  path: string;
  kind: 'image' | 'model' | 'audio' | 'video';
  status: 'missing' | 'supplied' | 'verified';
  license: string;
  description: string;
}
